'use client';

import { c as _c } from "react/compiler-runtime";
import * as AspectRatioPrimitive from '@radix-ui/react-aspect-ratio';
function AspectRatio(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <AspectRatioPrimitive.Root data-slot="aspect-ratio" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
export { AspectRatio };